export default __webpack_public_path__ + "images/Bigwood_Jacqueline_02.webp?fa7db59a403f357e5460f75b69631fbc";